/**
 * 인구통계 한 줄. select 가 아니라 칩이다 —
 * 선택지가 6~10개뿐이라 한눈에 보이고, 「안 고른 상태」가 기본값으로 보여야 한다.
 */
export default function Choice({ label, options, value, onChange }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <span className="note" style={{ fontWeight: 800, color: "var(--ink)" }}>{label}</span>
      <div role="group" aria-label={label} style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {options.map((o) => {
          const on = value === o;
          return (
            <button
              key={o}
              type="button"
              aria-pressed={on}
              // 같은 걸 다시 누르면 해제된다. 한 번 고르면 못 무르는 건 「선택」이 아니다.
              onClick={() => onChange(on ? null : o)}
              style={{
                padding: "6px 12px", borderRadius: 999, cursor: "pointer",
                border: "2px solid var(--ink)", fontSize: 14, fontWeight: 700,
                fontFamily: "inherit", lineHeight: 1.4,
                background: on ? "var(--ink)" : "transparent",
                color: on ? "var(--paper)" : "var(--ink)",
              }}
            >
              {o}
            </button>
          );
        })}
      </div>
    </div>
  );
}
